import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
  Tab,
  Form,
  Input,
  Table,
  Balloon,
  Message
} from '@alifd/next';
import LzTag from '@/components/common/LzTag';
// import FilterCondition from '@/components/sms/FilterCondition/FormNew';
import { CanvasService, Servlets } from '@/service';
import styles from '../../../index.module.scss';
import utils from '@/common/utils';
import CONSTANTS from '@/utils/constant';

// 人群过滤条件里对于checkbox是否勾选的标识
const baseFilterConditionCheckboxs = {
    filterAlreadySendTip: false,
    filterOrderCountTip: false,
    filterMaxMemberCountTip: false,
    filterLastOrderTimeTip: false,
    filterCrowdTip: false,
}

// tab选项卡
const panes = [
  {
    tab: '详情',
    key: 0,
  },
  {
    tab: '任务',
    key: 1,
  },
  // {
  //   tab: '报表',
  //   key: 2,
  // },
];
// 报表模式tab选项
const reportType = [
  {
    name: '汇总',
    key: 2,
    label: 'all',
  },
  {
    name: '触达',
    key: 0,
    label: 'touch',
  },
  {
    name: '点击',
    key: 1,
    label: 'click',
  },
];
// 报表时间tab选项
const reportTimeBase = [
  {
    name: '近3天',
    key: 3,
    label: 'three',
  },
  {
    name: '近5天',
    key: 5,
    label: 'five',
  },
  {
    name: '近7天',
    key: 7,
    label: 'seven',
  },
];
// 执行状态
const executionStatus = {
  1: '审核中',
  3: '审核通过',
  4: '驳回',
  5: '停止投放',
  100: '投放中',
  101: '短信投放成功',
  102: '投放失败',
  103: '执行成功',
};
export default ({
  activityInfo = {},
  initData = {},
  runState = {},
  changeData = (data) => {},
  onCancel = () => {},
}) => {
  // Tab展示 0：详情，1：任务 3：报表
  const [showTabkey, setShowTabkey] = useState('0');
  // 报表营销类型tab
  const [isActiveType, setActiveType] = useState(2);
  // 报表营销完成时间tab
  const [isActiveTime, setActiveTime] = useState(3);

  // 报表面板数据
  const [reportPane, setReportPane] = useState({
    ordPins: 0,
    payAmount: 0,
    payPins: 0,
    roi: 0,
  });
  // 报表表格数据
  const [tableData, setTabelData] = useState([]);

  // 组件内部的数据 原表单数据
  const [data, setData] = useState({
    ...initData,
  });
  // 节点运行时详情数据
  const [state, setState] = useState({
    ...runState,
  });
  // 标识短信节点任务执行成功后成功人数信息是否展示（失败不展示）
  const [isSuccessNode, setIsSuccessNode] = useState(
    !!(state.variables && state.variables[0] && state.variables[0].prepNum)
  );
  /**
   * 处理过长数字添加逗号分隔
   */
  const numberFormat = (values) => {
    const value = `${values}`;
    if (!value) return '0';
    const intPart = Number(value) | 0;
    const intPartFormat = intPart
      .toString()
      .replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
    let floatPart = '';
    const value2Array = value.split('.');
    if (value2Array.length == 2) {
      floatPart = value2Array[1].toString();
      if (floatPart.length == 1) {
        return intPartFormat;
      } else {
        return intPartFormat;
      }
    } else {
      return intPartFormat + floatPart;
    }
  };

  /**
   * 刷新短信余额
   */
  const frashCount = (isReFresh = false) => {
    // CanvasService.getSmsNum()
    //   .then((res) => {
    //     onChange({ smsCount: res.data });
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //   });
    Servlets('getPageSmsNum').then((res: { data: number }) => {
      if (res.data === undefined) {
        return;
      }
      onChange({ smsCount: res.data })
      if (isReFresh) Message.success('余额已刷新');
    });
  };

  /**
   * 查询报表数据-面板数据
   * @param v.flag-左侧不同维度切换
   * @param v.time-右侧时间切换
   */
  const getSMSSummaryEffect = (v) => {
    const startTime =
      new Date(moment(state.activityInfo?.startTime).format('YYYY-MM-DD')) || 0;
    startTime.setHours(0); // 设置小时
    startTime.setMinutes(0); // 设置分钟
    startTime.setSeconds(0); // 设置秒
    startTime.setMilliseconds(0);
    const startT = startTime.getTime();
    const params = {
      flag: v.flag,
      startTime: startT,
      endTime: startT + 86400000 * (v.time - 1),
      taskInstId: state.activityInfo.jobId,
    };
    CanvasService.getSMSSummaryEffect(params)
      .then((res) => {
        setReportPane(res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  /**
   * 查询列表数据
   */
  const getSMSTaskEffect = (v) => {
    const startTime =
      new Date(moment(state.activityInfo?.startTime).format('YYYY-MM-DD')) || 0;
    startTime.setHours(0); // 设置小时
    startTime.setMinutes(0); // 设置分钟
    startTime.setSeconds(0); // 设置秒
    startTime.setMilliseconds(0);
    const startT = startTime.getTime();
    const param = {
      flag: isActiveType,
      startTime: startT,
      endTime: startT + 86400000 * (isActiveTime - 1), // isActiveTime是选择的时间范围，3，5，7日内，所以把开始时间累加上去
      taskInstId: state.activityInfo.jobId,
      ...v,
    };
    CanvasService.getSMSTaskEffect(param)
      .then((res) => {
        setTabelData(res.data.smsEffectResponseList);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  /**
   * 点击退出
   */
  // const cancel = () => {
  //   setSelectCrow(false);
  // };

  /**
   * 合并新旧状态
   */
  const onChange = (newData) => {
    setData({
      ...data,
      ...newData,
    });
  };

  useEffect(() => {
    frashCount();
  }, []);

  useEffect(() => {
    const startTime =
      new Date(moment(state.activityInfo?.startTime).format('YYYY-MM-DD')) || 0;
    startTime.setHours(0); // 设置小时
    startTime.setMinutes(0); // 设置分钟
    startTime.setSeconds(0); // 设置秒
    startTime.setMilliseconds(0);
    const startT = startTime.getTime();
    if (
      showTabkey === '2' &&
      state.activityInfo &&
      state.activityInfo.startTime
    ) {
      getSMSSummaryEffect({ flag: isActiveType, time: isActiveTime });
      getSMSTaskEffect();
    }
  }, [showTabkey]);

  const [filterMaxMemberCountReal, setFilterMaxMemberCountReal] = useState(1);
  const [filterConditionCheckboxs, setFilterConditionCheckboxs] = useState({
    ...baseFilterConditionCheckboxs
  });
  // useEffect(() => {
  //   const num = utils.calcSmsNumber(data.smsContent.replace(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`,''), data.smsSign); // 计算出当前的短信内容会成为几条短信
  //   const real = Math.floor(data.filterMaxMemberCount / num); // 这个是为了在选择附加条件过滤链发送上限时，把条数计算出人数
  //   setFilterMaxMemberCountReal(real ? real : 0);

  //   setFilterConditionCheckboxs({
  //   ...filterConditionCheckboxs,
  //   filterAlreadySendTip: data.filterAlreadySend ? true : false,
  //   filterOrderCountTip: data.filterOrderCount ? true : false,
  //   filterMaxMemberCountTip: data.filterMaxMemberCount ? true : false,
  //   filterLastOrderTimeTip: data?.filterLastOrderTime ? true : false,
  //   filterCrowdTip: data?.filterCrowdId ? true : false,
  //   });
  // }, [data.smsContent, data.smsSign, data.filterMaxMemberCount]);

  return (
    <div
      className={`page-Padding ${styles.detailRoot} ${styles.sendMessageRoot} canvasDetailDialog`}
      style={{ padding: '30px' }}
    >
      <div className="second-level">
        <Tab shape="wrapped" onChange={setShowTabkey}>
          {panes.map((pane) => (
            <Tab.Item
              title={pane.tab}
              key={pane.key}
              className="justify-tabs-tab"
              style={{
                display:
                  pane.tab === '报表'
                    ? !state.activityInfo ||
                      JSON.stringify(state.activityInfo) === '{}' ||
                      state.activityInfo.errorMsg
                      ? 'none'
                      : 'inline-block'
                    : 'inline-block',
                borderRightColor:
                  pane.tab === '任务'
                    ? !state.activityInfo ||
                      JSON.stringify(state.activityInfo) === '{}' ||
                      state.activityInfo.errorMsg
                      ? '#C4C6CF'
                      : 'transparent'
                    : '#C4C6CF',
              }}
            />
          ))}
        </Tab>
      </div>
      {showTabkey === '0' && (
        <Form className={`canvasDialog ${styles.detailDiv}`}>
          <Form.Item label="节点ID:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>
              {state.nodeId ? state.nodeId : '--'}
            </div>
          </Form.Item>
          {/* {utils.isPGShop() && (
            <Form.Item label="PO号:">
              <div className={`formItemWidth ${styles.lineHeightNormal}`}>
                {data.poOrderId}
              </div>
            </Form.Item>
          )} */}
          <Form.Item label="节点名称:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>
              {data.name}
            </div>
          </Form.Item>
          <Form.Item label="发送时间:">
            <>
              {data.cycleType === 1 && (
                <div className={`formItemWidth ${styles.lineHeightNormal}`}>
                  {data.executionTime === 0 ? '立即执行' : moment(data.executionTime).format('YYYY-MM-DD HH:mm')}
                </div>
              )}
              {data.cycleType === 2 && (
                <div className={`formItemWidth ${styles.lineHeightNormal}`}>
                  {(data.executionTime - data.executionMinute * 60000) /
                    3600000}
                  时{data.executionMinute}分
                </div>
              )}
            </>
          </Form.Item>
          <Form.Item label="短信签名:">
            <div className={`${styles.displayFlex} ${styles.smsSign}`}>
              <Input
                name="messageSign"
                value={data.smsSign}
                size="medium"
                disabled
              />
            </div>
          </Form.Item>
          <Form.Item label="短信内容:">
            <div style={{ marginTop: '10px', width: '300px' }}>
              {/* <Input.TextArea disabled className={`formItemWidth`} name="messageContent" placeholder="请输入" size="small" value={data.messageContent} autoHeight={{ minRows: 6, maxRows: 10 }}/> */}
              <div className={styles.smsContent}>
                <div>
                  {data.shortLink
                    ? data.smsContent
                        .replace('#oldshortLink', data.shortLink)
                        .replace(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`, '')
                    : data.smsContent.replace(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`, '')}
                </div>
                {/* <div className={styles.smsWords}>{data.smsWords}/70  第 <span style={{color:'#ff3333'}}>{data.smsNum}</span> 条</div> */}
              </div>
              <div className={`${styles.messageSign} ${styles.shortLink}`}>
                <div className="shortLink">
                  短信规则说明
                  <Balloon
                    trigger={
                      <span
                        className="iconfont icon-icon4-33"
                        style={{ color: '#9ca7b6', paddingLeft: '5px' }}
                      />
                    }
                    closable={false}
                    align="t"
                  >
                    1、每条短信内容最长 329 个字符（包括签名、空格）
                    <br />
                    2、短信内容只能为普通字符，不能包含：【、】、）、表情符
                    等特殊字符
                    <br />
                    3、第一条短信按70字计，第二条开始按67字每条计
                    <br />
                    4、一个汉字，字母或者标点都算一个字
                    <br />
                    {`5、受短信运营商限制，签名和${CONSTANTS.LZ_SMS_CANCEL_WORD}，包含在字数中`}
                    <br />
                  </Balloon>
                </div>
              </div>
            </div>
          </Form.Item>
          {/* <Form.Item label="附加条件：">
                <FilterCondition
                    params={{
                        ...data,
                        filterAlreadySend: data.filterAlreadySend ? data.filterAlreadySend : null,
                        filterOrderCount: data.filterOrderCount ? data.filterOrderCount : null,
                        filterMaxMemberCount: data.filterMaxMemberCountShow ? data.filterMaxMemberCountShow : null,
                        filterLastOrderTime: data?.filterLastOrderTime ? data?.filterLastOrderTime : null,
                        filterCrowdId: data?.filterCrowdId ? data?.filterCrowdId : null,
                        filterCrowdName: data?.filterCrowdName ? data?.filterCrowdName : null,
                    }}
                    setCreateParams={(v) => {
                    }}
                    filterCondition={filterConditionCheckboxs}
                    setFilterCondition={(v) => {
                    }}
                    filterMaxMemberCountReal={filterMaxMemberCountReal}
                    checkType={true}
                    jumpUrl={1}
                    sourceType={1}
                />
          </Form.Item> */}
          <Form.Item label="短信账户:">
            <div style={{ lineHeight: '28px' }}>
              可用余额 <span className={styles.smsCount}>{data.smsCount}</span>{' '}
              条{' '}
              <span
                style={{ marginLeft: '10px' }}
                className={styles.globalLink}
                onClick={() => frashCount(true)}
              >
                {' '}
                刷新
              </span>
            </div>
          </Form.Item>
        </Form>
      )}
      {showTabkey === '1' && (
        <Form
          className={`${styles.formDiv} ${styles.taskRoot} canvasDialog`}
          style={{ textAlign: 'left' }}
        >
          <Form.Item label="任务ID:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>
              {state.activityInfo && state.activityInfo.jobId
                ? state.activityInfo.jobId
                : '--'}
            </div>
          </Form.Item>
          <Form.Item label="任务执行周期:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>
              {state.activityInfo && state.activityInfo.startTime && state.activityInfo.startTime !== -1
                ? `${moment(state.activityInfo.startTime).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )} 至 `
                : '--'}
              {state.activityInfo &&
              state.activityInfo.endTime &&
              state.activityInfo.endTime !== -1
                ? moment(state.activityInfo.endTime).format(
                    'YYYY-MM-DD HH:mm:ss'
                  )
                : ''}
            </div>
          </Form.Item>
          <Form.Item label="状态:">
            <div className={`formItemWidth ${styles.lineHeightNormal}`}>
              {/* {
              (state.activityInfo && state.activityInfo.endTime && state.activityInfo.endTime !== -1 && !state.activityInfo.errorMsg) && <LzTag.Success>执行成功</LzTag.Success>
            } */}
              {/* resultNotify状态： 4 5 102 103 */}
              {state.activityInfo &&
                state.activityInfo.endTime &&
                state.activityInfo.endTime !== -1 &&
                !state.activityInfo.errorMsg &&
                state.variables?.[0].resultNotify && (
                  <>
                    {state.variables[0].resultNotify === 103 ? (
                      <LzTag.Success>
                        {executionStatus[state.variables?.[0].resultNotify]}
                      </LzTag.Success>
                    ) : (
                      <LzTag.Error>
                        {executionStatus[state.variables?.[0].resultNotify]}
                      </LzTag.Error>
                    )}
                  </>
                )}
              {/* resultNotify状态： 1 3 100 101 */}
              {state.activityInfo &&
                state.activityInfo.endTime &&
                state.activityInfo.endTime === -1 &&
                !state.activityInfo.errorMsg &&
                state.variables?.[0].resultNotify && (
                  <LzTag.Success>
                    {executionStatus[state.variables?.[0].resultNotify]}
                  </LzTag.Success>
                )}
              {/* resultNotify状态： '' */}
              {state.activityInfo &&
                state.activityInfo.startTime &&
                state.activityInfo.endTime === -1 &&
                !state.activityInfo.errorMsg &&
                !state.variables?.[0].resultNotify && (
                  <LzTag.Success>执行中...</LzTag.Success>
                )}
              {(!state.activityInfo ||
                JSON.stringify(state.activityInfo) === '{}') && (
                <LzTag.Warning>未执行</LzTag.Warning>
              )}
              {state.activityInfo && state.activityInfo.errorMsg && (
                <LzTag.Error>
                  执行失败 {state.activityInfo.errorMsg}
                </LzTag.Error>
              )}
              <div
                className={styles.taskStatistics}
                style={{
                  display:
                    state.activityInfo &&
                    state.activityInfo &&
                    state.activityInfo.startTime &&
                    state.activityInfo.endTime &&
                    state.activityInfo.endTime !== -1
                      ? 'block'
                      : 'none',
                }}
              >
                <div>
                  提交人数:{' '}
                  {isSuccessNode
                    ? numberFormat(state.variables[0].prepNum)
                    : '--'}
                </div>
                <div>
                  发送成功人数:{' '}
                  {isSuccessNode
                    ? numberFormat(state.variables[0].resultNum)
                    : '--'}
                </div>
                <div>
                  发送失败人数:{' '}
                  {isSuccessNode
                    ? numberFormat(
                        state.variables[0].prepNum -
                          state.variables[0].resultNum
                      )
                    : '--'}
                </div>
                <div>
                  发送成功率:{' '}
                  {isSuccessNode
                    ? `${
                        (Math.round(
                          (state.variables[0].resultNum /
                            state.variables[0].prepNum) *
                            100
                        ) /
                          100) *
                        100
                      }%`
                    : '--'}
                </div>
              </div>
            </div>
          </Form.Item>
        </Form>
      )}
      {showTabkey === '2' && (
        <div className={styles.reportRoot}>
          <div className={`${styles.displayFlex} ${styles.sendEndTime}`}>
            <div className={`${styles['type-list']}`}>
              {reportType.map((i, index) => (
                <a
                  key={i.key}
                  className={`${styles.globalLink} ${
                    i.key == isActiveType ? styles.active : ''
                  }`}
                  onClick={() => {
                    setActiveType(i.key),
                      getSMSSummaryEffect({ flag: i.key, time: isActiveTime }),
                      getSMSTaskEffect({ flag: i.key });
                  }}
                >
                  {i.name}
                </a>
              ))}
            </div>
            <div className={`${styles.displayFlex}`}>
              <div>营销完成后:</div>
              <div className={styles['time-list']}>
                {reportTimeBase.map((i, index, arr) => (
                  <span
                    key={i.key}
                    className={i.key == isActiveTime ? styles.active : ''}
                    onClick={() => {
                      setActiveTime(i.key),
                        getSMSSummaryEffect({
                          flag: isActiveType,
                          time: i.key,
                        });
                    }}
                  >
                    {' '}
                    {i.name}{' '}
                    <span
                      className={styles.lines}
                      style={{ display: index == arr.length - 1 ? 'none' : '' }}
                    >
                      {' '}
                      |{' '}
                    </span>
                  </span>
                ))}
              </div>
            </div>
          </div>
          <div className={`${styles.displayFlex} ${styles.reportStatistics}`}>
            {/* TODO: 感觉这个应该写成循环，而不是一行一行定义 */}
            <div>
              <div>累计下单人数</div>
              <div>{numberFormat(reportPane.ordPins)}</div>
            </div>
            <div>
              <div>累计付款人数</div>
              <div>{numberFormat(reportPane.payPins)}</div>
            </div>
            <div>
              <div>累计付款金额</div>
              <div>{numberFormat(reportPane.payAmount)}</div>
            </div>
            <div>
              <div>ROI</div>
              <div>{numberFormat(reportPane.roi)}</div>
            </div>
          </div>
          <div
            style={{ textAlign: 'right', lineHeight: '24px' }}
            className={styles.globalLink}
            onClick={() =>
              window.open(
                `../../../../canvas/activities/data/analysis/${activityInfo.id}`
              )
            }
          >
            数据导出
          </div>
          <Table
            dataSource={tableData}
            className={styles.customTable}
            fixedHeader
          >
            <Table.Column
              align="center"
              title="日期"
              key="reportDate"
              cell={(value, index, item) => (
                <span>
                  {moment(Number(item.reportDate)).format('YYYY-MM-DD')}
                </span>
              )}
            />
            <Table.Column
              align="center"
              title="下单人数"
              dataIndex="ordPins"
              key="ordPins"
            />
            <Table.Column
              align="center"
              title="下单金额"
              dataIndex="ordAmount"
              key="ordAmount"
            />
            <Table.Column
              align="center"
              title="付款人数"
              dataIndex="payPins"
              key="payPins"
            />
            <Table.Column
              align="center"
              title="付款金额"
              dataIndex="payAmount"
              key="payAmount"
            />
          </Table>
        </div>
      )}
    </div>
  );
};
